import ChooseAdverb from "../../components/ClassOne/English/ChooseAdverb";
import FillInTheBlanksAdverbs from "../../components/ClassOne/English/FillInTheBlanksAdverbs";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/english/adverbs/write-the-adverbs", title: "Choose the Adverb", component: ChooseAdverb },
    { url: "/class-one/english/adverbs/fill-the-blanks", title: "Fill in the Blanks", component: FillInTheBlanksAdverbs },
];


export default topics;